// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"566":"45692589","973":"06406440"}[chunkId] + ".chunk.css";
};